<template>
  <div class='body-box marginBox'>
    <el-row class='plan' :gutter="20">
      <el-col :span='24'>
        <el-tabs v-model="activeName" @tab-click="btnStatus">
          <el-tab-pane label="待确定" name="CONFIRM"></el-tab-pane>
          <el-tab-pane label="已使用" name="USED"></el-tab-pane>
          <el-tab-pane label="未使用" name="NOT_USED"></el-tab-pane>
          <el-tab-pane label="已过期" name="OVERDUE"></el-tab-pane>
          <el-tab-pane label="全部" name="ALL"></el-tab-pane>
        </el-tabs>
      </el-col>

      <el-col :span='14' class="radioBox">
        <el-button @click="searchSaleType('COURT')" :class="{current: queryInfo.type === 'COURT' }">球场</el-button>
        <el-button @click="searchSaleType('TRAVEL')" :class="{current: queryInfo.type === 'TRAVEL' }">旅行</el-button>
        <el-button @click="searchSaleType('GOODS')" :class="{current: queryInfo.type === 'GOODS' }">商品</el-button>
        <el-button @click="searchSaleType('')" :class="{current: queryInfo.type === '' }">全部</el-button>
      </el-col>

      <el-col :span='5'>
        <search-input v-model='queryInfo.keyword' placeholder='SALE名称' @change="handleQuery"/>
      </el-col>
      <el-col :span='5'>
        <search-input v-model="queryInfo.orderNo" placeholder='订单号' @change="handleQuery"/>
      </el-col>
    </el-row>


    <el-table :height="'calc(100% - 120px)'" :data='orderList' class='button-box'>
      <el-table-column label='订单编号' prop='orderNum' />
      <el-table-column label='SALE名称' prop='name' />
      <el-table-column label='SALE类型' prop='enumType'>
        <template slot-scope='scope'>
          {{ scope.row.enumType | SaleType }}
        </template>
      </el-table-column>
      <el-table-column label='价格' prop='price' />
      <el-table-column label='数量' prop='num' />
      <el-table-column label='总价' prop='cost' />
      <el-table-column label='BlueTeeId' prop='blueTeeId' />
      <el-table-column label='预约人' prop='userName' />
      <el-table-column label='电话' prop='tel' />
      <el-table-column label='邮箱' prop='email' />
      <el-table-column label='是否支付'>
        <template slot-scope="scope">{{scope.row.enumPay === 'YES' ? '已支付' : '未支付'}}</template>
      </el-table-column>
      <el-table-column label='状态' prop='enumStatus'>
        <template slot-scope='scope'>
          <div
            :style="{ color:
            [scope.row.enumStatus === 'CONFIRM' ? 'green' : (scope.row.enumStatus === 'USED') ? 'red' : (scope.row.enumStatus === 'NOT_USED')
            ?'Lime':''] }">
            {{ scope.row.enumStatus | orderStatus }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label='操作' min-width='100' fixed="right">
        <template slot-scope='scope'>
          <el-popover placement="right" trigger="click">
            <div class="foldBtnBox">
              <div><el-button @click='getUserInfoByOrder(scope.row)'>查看下单用户信息</el-button></div>
              <div><el-button @click='updateStatusDialog(scope.row)'>修改状态</el-button></div>
              <div><modify-cost :orderCost='scope.row.cost' :orderId='scope.row.id' @change='handleQuery'></modify-cost></div>
              <div><delete-order :orderId='scope.row.id' orderType='SALE' @change='handleQuery'></delete-order></div>
            </div>
            <el-button slot="reference">更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>

    <div class="fixedBox"><pagination ref='page' :query-param.sync='queryInfo' @pagination='getOrderList'></pagination></div>

    <el-dialog title='修改订单' :visible.sync='updateOrderStatusDialog' width='30%'>
      <el-form label-width='80px'>
        <el-form-item label='是否支付'>
          <el-select style='width: 100%;margin-bottom: 20px;' v-model='orderStatus.enumPay' placeholder='请选择是否支付'>
            <el-option key='YES' label='已支付' value='YES'></el-option>
            <el-option key='NO' label='未支付' value='NO'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label='修改状态'>
          <el-select style='width: 100%;' v-model='orderStatus.enumStatus' placeholder='请选择订单状态'>
            <el-option
              v-for='item in saleStatus'
              :key='item.id'
              :label='item.name'
              :value='item.value'>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>


      <span slot='footer' class='dialog-footer'>
        <el-button @click='updateOrderStatusDialog = false'>取 消</el-button>
        <el-button type='primary' @click='updateStatus'>确 定</el-button>
      </span>
    </el-dialog>
    <!--获取用户信息-->
    <user-info ref='getUserInfo'></user-info>
  </div>
</template>

<script>
import { getSaleOrderList, updateOrderStatus } from '@/api/order/order'
import { getData } from '@/utils/code'
import { orderSaleStatus } from '@/js/enum'
import DeleteOrder from '@/components/common/deleteOrder/deleteOrder'
import ModifyCost from '@/components/common/modifyCost/modifyCost'
import UserInfo from '@/components/common/user/userInfo'
import Pagination from '@/components/common/Pagination/index'
import SearchInput from '@/components/common/searchInput/searchInput'

export default {
  name: 'saleOrder',
  components: { SearchInput, DeleteOrder, ModifyCost, UserInfo, Pagination },
  data() {
    return {
      activeName: 'CONFIRM',
      orderList: [],
      // 查询参数
      queryInfo: {
        keyword: '',
        enumStatus: 'CONFIRM',
        type: 'COURT'
      },
      updateOrderStatusDialog: false,
      id: '',
      orderStatus: {
        enumStatus: ''
      },
      saleStatus: orderSaleStatus
    }
  },
  created() {
    this.handleQuery()
  },

  watch: {
    queryInfo(newData) {
      this.activeName = newData.enumStatus === '' ? 'ALL' : newData.enumStatus
    }
  },

  methods: {
    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },

    //获取列表
    getOrderList(page, cb) {
      getSaleOrderList(page).then((res) => {
        this.orderList = cb(res)
      })
    },

    //按钮状态
    btnStatus(val) {
      this.queryInfo.enumStatus = val.name === 'ALL' ? '' : val.name
      this.handleQuery()
    },
    searchSaleType(type) {
      this.queryInfo.type = type
      this.handleQuery()
    },

    //修改状态
    updateStatusDialog(row) {
      this.updateOrderStatusDialog = true
      let obj = JSON.parse(JSON.stringify(row))
      this.id = obj.id
      this.orderStatus.enumStatus = obj.enumStatus
    },

    //修改
    updateStatus() {
      updateOrderStatus(this.id, this.orderStatus).then((res) => {
        let data = getData(res)
        if (data != null) {
          this.$message.info('修改成功!')
          this.handleQuery()
          this.updateOrderStatusDialog = false
        }
      })
    },

    //查看sale订单页面
    look(row) {
      if (row.enumType === 'COURT') {
        this.$router.push({
          path: '/viewDetails',
          query: {
            id: row.refId
          }
        })
      }

      if (row.enumType === 'TRAVEL') {
        this.$router.push({
          path: '/viewTravel',
          query: {
            id: row.refId
          }
        })
      }

      if (row.enumType === 'GOODS') {
        this.$router.push({
          path: '/viewGoods',
          query: {
            id: row.refId
          }
        })
      }
    },
    //查看下单用户信息
    getUserInfoByOrder(row) {
      this.$refs.getUserInfo.getUserInfo(row.userInfo)
    }
  }
}
</script>

<style scoped>

</style>
